import React from 'react';
import { Styled } from './Button';
import { Link } from 'react-router-dom';

const HomeButton = () => {
  return (
    <Styled disabled={false} buttonColor={'white'}>
      <Link to="/">トップページに戻る</Link>
    </Styled>
  );
};

export default HomeButton;
